import { ICrewMember } from './../models';
import { noSpaces } from './wordFormatting';

export const formatCastMember = (member: Partial<ICrewMember>) => {
  if (!member || !member.name || !member.personId) {
    return { name: '', personId: '' };
  }
  const formattedPersonId = member.personId.replace(/person-/, '');
  const formattedName = noSpaces(member.name);

  return { name: formattedName, personId: formattedPersonId };
};
